export const GET_JACKETS_INFO = "GET_JACKETS_INFO";
export const GET_JACKETS_INFO_SUCCESS = "GET_JACKETS_INFO_SUCCESS";
export const GET_JACKETS_INFO_ERROR = "GET_JACKETS_INFO_ERROR";

export const PUT_JACKET_INTERNAL_STATUS = "PUT_JACKET_INTERNAL_STATUS";
export const PUT_JACKET_INTERNAL_STATUS_SUCCESS =
  "PUT_JACKET_INTERNAL_STATUS_SUCCESS";
export const PUT_JACKET_INTERNAL_STATUS_ERROR =
  "PUT_JACKET_INTERNAL_STATUS_ERROR";
